import React from 'react';
// import { setActiveUser, setUserLogoutState } from '../../features/userSlice.js';
// import { useDispatch } from 'react-redux';
// import { auth } from '../../firebase';
// import { DualRing } from 'react-awesome-spinners';
// import { useNavigate } from 'react-router-dom';
import SliderImage from '../../components/SliderImage/SliderImage';
import FontsDefault from '../../Assistant/DefaultStyle';
import { DefaultFlex } from '../../Assistant/DefaultStyle';
import Button from '../../components/Button/Button';
import Footer from '../../components/Footer/Footer';
import TeamCard from '../../components/TeamCard/TeamCard';
import { motion } from 'framer-motion';
const DUMMY_DATA_DEV = [
  {
    name: 'ياسر أبو كويك',
    key: '1',
    title: 'استشاري تسويق رقمي',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/WhatsApp%20Image%202022-09-11%20at%2012.52.05%20PM.jpeg?alt=media&token=19a3f5c2-e507-4321-bea0-264233828bbf',
    description:
      'اعمل كاستشاري تسويق لعدد من الشركات والمؤسسات ،خبرة تجاوزت 10 سنوات في مجال التسويق واعداد الخطط التسويقية',
  },

  {
    name: 'معتصم عماد',
    key: '2',
    title: 'مطور ويب',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/WhatsApp%20Image%202022-09-11%20at%202.15.55%20PM.jpeg?alt=media&token=d5d7a52a-3a90-416f-9515-d9eaa553cb62',
    description:
      'خريج من الكلية الجامعية للعلوم التطبيقية ,مطور ويب وتطبيقات الهواتف الذكية ،لدي خبرة تزيد عن الثلاث سنوات ، شغوف بالتكنولوجيا ، وأنا أستمتع بالبرمجة ، وأنا دائمًا على اطلاع دائم و  لست خائفًا من الخوض في مواقف ولغات جديدة .',
  },

  {
    name: 'محمد سعيد ',
    key: '3',
    title: 'مهندس برمجيات',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/WhatsApp%20Image%202022-09-11%20at%209.15.11%20PM.jpeg?alt=media&token=464b47ef-86a2-4543-98c7-8fbb8270e866',
    description:
      'مهندس برمجيات لدي خبرة قوية في تصميم الواجهة الامامية للويب قمت بالعمل على العديد من المشاريع الرائعة وأيضا أحب تحويل التصميمات الجميلة إلى مواقع ويب قابلة للاستخدام تستجيب لمختلف الأجهزة وقابلة للتطوير.',
  },

  {
    name: 'تسنيم رائد',
    key: '11',
    title: 'مصصمة جيرافيك',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/photo_2022-09-12_09-30-10.jpg?alt=media&token=6e491a14-3726-4afa-ae7e-e0489f168073',
    description:
      'مصممة جرافيك ،خريجة من الكلية الجامعية التطبيقية ،لدي خبرة تزيد عن الثلاث سنوات ، مختصة بتصميم (الشعارات،بطاقات الأعمال ،المطبوعات "بروشورات-بوسترات"،إعلانات السوشيال ميديا ) اعتبر التصميم عالم سحري , ولدي عصاً سحرية ،أقدم الخدمات بجودة عالية ستجعل عملك اكثر انتاجية وفعالية .',
  },

  {
    name: 'غيداء اللحام',
    key: '4',
    title: 'مصممة جيرافيك',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/WhatsApp%20Image%202022-09-11%20at%201.21.31%20PM.jpeg?alt=media&token=239d1e2c-5f42-4eda-a7e5-78da40a9f3f3',
    description:
      'خريجة بكالوريوس تكنولوجيا الوسائط المتعددة، خبرة في العمل لا تقل عن أربع سنوات ، مصممة جرافيك متخصصة في التصميم الجرافيكي ببراعة وتميز وأضفي طابع الجمال بلمسات فنية ، تصميم هويات بصرية وكل ما يخص السوشيال ميديا.',
  },

  {
    name: 'الاء فروانة',
    key: '5',
    title: 'مديرة صفحات سوشيال ميديا',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/WhatsApp%20Image%202022-09-11%20at%2012.51.56%20PM.jpeg?alt=media&token=065becd7-6d07-428d-a99b-3d6edd4ff7a2',
    description:
      'خريجة أدب اللغة انجليزية ، متخصصة في مجال ادارة صفحات السوشيال ميديا بجيمع انواعها (فيس بوك ،تويت، سناب شات ،تيك توك ،انستجرام) .',
  },

  {
    name: 'صفاء قنديل',
    key: '10',
    title: 'معلقة صوتية',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/WhatsApp%20Image%202022-09-11%20at%2011.50.46%20AM.jpeg?alt=media&token=7e01d8d2-3f30-4782-aef6-de4c2eb69409',
    description:
      'خريجة صحافة وإعلام من الجامعة الإسلامية بغزة ،معلقة صوتية للعديد من اللهجات العربية بـخبرة تزيد عن خمس سنوات مدبلجة للرسوم المتحركة بأصوات مختلفة.',
  },

  {
    name: 'دنيا عمار',
    key: '7',
    title: 'كاتبة محتوى',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/WhatsApp%20Image%202022-09-11%20at%2012.10.17%20PM.jpeg?alt=media&token=e04ca8b1-4eaa-47dc-ade0-847b226120c4',
    description:
      'خريجة لغة عربية وأساليبها، خبرة (5) سنوات في كتابة المحتوى بما يتوافق مع SEO باللغتين العربية والانجليزية، ومتخصصة في إعداد الملفات التعريفية لشركات والمؤسسات باللغتين العربية والانجليزية.',
  },

  {
    name: 'أميرة الخزندار ',
    key: '8',
    title: 'كاتبة المحتوى',
    img: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/WhatsApp%20Image%202022-09-11%20at%2012.52.11%20PM.jpeg?alt=media&token=1b37beef-e7d1-4b85-817e-a647c1f35c5d',
    description:
      'خريجة كلية التربية ، أمتلك خبرة لا تقل عن أربع سنوات في كتابة المحتوى والتدقيق اللغوي في مختلف الموضوعات، خبرة واسعة في برامج مايكروسوفت أوفس، وتطبيقات Google.',
  },
];

function Team() {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const getData = () => {
  //     auth.onAuthStateChanged((authUser) => {
  //       if (authUser) {
  //         setLoading(true);
  //         dispatch(
  //           setActiveUser({
  //             userName: authUser.displayName,
  //             userEmail: authUser.email,
  //           })
  //         );
  //         setLoading(false);
  //       } else {
  //         setLoading(true);
  //         dispatch(setUserLogoutState());
  //         navigate('/login');
  //         setLoading(false);
  //       }
  //     });
  //   };
  //   getData();
  // }, [dispatch, loading, navigate]);

  //   <div className='flex justify-center items-center h-screen w-full'>
  //   <DualRing size={100} color='#22c55e' />
  // </div>

  return (
    <motion.div
      initial={{ width: 0, opacity: 0 }}
      animate={{ width: '100vw', opacity: 1 }}
      exit={{
        width: window.innerWidth,
        opacity: 0,
        transition: { duration: 0.1 },
      }}
    >
      <SliderImage />

      <div className={`${FontsDefault.defaultContainerWidth}`}>
        <div className={`${DefaultFlex} items-center mb-6`}>
          <div>
            <h1
              className={`py-3 ${FontsDefault.text4xl} font-bold text-amber`}
            >
              فريق العمل
            </h1>
          </div>
          <div>
            <Button title='تواصل معنا الان' />
          </div>
        </div>
        <div className='grid xl:grid-cols-3 lg:grid-cols-2 grid-col-1 gap-8 w-full'>
          {DUMMY_DATA_DEV.map((item) => (
            <TeamCard item={item} key={item.key} />
          ))}
        </div>
      </div>
      <Footer />
    </motion.div>
  );
}

export default Team;
